export enum VariableType {
  ENERGY_EFFICIENCY = 'ENERGY_EFFICIENCY',
  ENERGY_INTENSITY = 'ENERGY_INTENSITY',
  RESOURCE_COEFFICIENT = 'RESOURCE_COEFFICIENT',
  EMISSION_FACTOR = 'EMISSION_FACTOR',
  RESOURCE_PROPORTION = 'RESOURCE_PROPORTION',
  WORK_TO_RESOURCE = 'WORK_TO_RESOURCE',
  OPERATIONS = 'OPERATIONS',
  WORK = 'WORK',
  GROWTH_FACTOR = 'GROWTH_FACTOR',
}

export interface IVariable {
  variable: string;
  unitOfMeasure: string;
  max?: number;
  min?: number;
  type?: VariableType;
}
